import moment from 'moment-timezone';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { ArrowBack, } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useAuth } from "./context/AuthContext";
moment.locale('es');

export const Header = ({ evento }) => {
  const { user } = useAuth();
  const location = useLocation();
  const param = useParams();
  const history = useHistory();
  const [titulo, setTitulo] = useState('')
  const [subtitulo, setSubtitulo] = useState('');
  const [icono, setIcono] = useState('');
  const { t } = useTranslation("global");
  const [showBackButton, setShowBackButton] = useState(true);

  const isVentaPresencial = location.pathname.includes('/venta-presencial');

  const participacion = user?.participaciones?.find(
    (p) => p.idevento === Number(param.id)
  );

  const esVendedorOTesorero = participacion && (participacion.idrol === 9 || participacion.idrol === 10);

  useEffect(() => {
    const url = "/eventos/" + param.id;

    setShowBackButton(location.pathname !== url)
  }, [location.pathname, param.id]);

  useEffect(() => {
    const url = "/eventos/" + param.id;

    switch (location.pathname) {
      case url:
        setTitulo('')
        setSubtitulo('');
        break;
      case url + "/ubicaciones":
        setTitulo("Ubicaciones");
        setSubtitulo('');
        break;
      case url + "/tarifas":
        setTitulo("Entradas y precios");
        setSubtitulo('');
        break;
      case url + "/creartarifa":
        setTitulo("Crear entrada");
        setSubtitulo('');
        break;
      case url + "/staff":
        setTitulo("Staff");
        setSubtitulo(t("Gestionar personal"));
        break;
      case url + "/tickets":
        setTitulo("Tickets");
        setSubtitulo('');
        break;
      case location.pathname.match(new RegExp(`${url}/tickets/\\d+/accesos`)) ? location.pathname : '':
        setTitulo("Historial de Accesos");
        setSubtitulo('Visualizá todos los registros de entradas y salidas de este ticket.');
        break;
      case location.pathname.match(new RegExp(`${url}/tickets/\\d+`)) ? location.pathname : '':
        setTitulo("Ticket");
        setSubtitulo('');
        break;
      case url + "/vouchers":
        setTitulo("Vouchers");
        setSubtitulo('');
        break;
      case url + "/ventas":
        setTitulo("Ventas realizadas");
        setSubtitulo('');
        break;
      case url + "/cuentas":
        setTitulo("Cobros y pagos");
        setSubtitulo('Acá podés vincular las cuentas donde querés recibir los fondos de tus ventas. Seleccioná el medio de pago que usás y seguí los pasos para conectarlo.');
        break;
      case url + "/crear-cuenta":
        setTitulo(t("menuTemplate.wallet"));
        setSubtitulo(t("button.add"))
        break;
      case url + "/publicaciones":
        setTitulo(t("menuTemplate.publications"));
        setSubtitulo('Acá vas a completar y editar la información que se muestra en la tarjeta de tu evento en el inicio de la plataforma. Esa tarjeta incluye la imagen, el título y el resumen breve del evento que verán todos los usuarios.')
        break;
      case url + "/publicaciones/nueva":
        setTitulo(t("menuTemplate.publications"));
        setSubtitulo(t("button.create"))
        break;
      case url + "/colaboradores":
        setTitulo(t("menuTemplate.collaborators"));
        setSubtitulo('');
        break;
      case url + "/nuevoVoucher":
        setTitulo('Vouchers');
        setSubtitulo(t("button.create"));
        break;
      case url + "/nuevoVoucher/importarExcel":
        setTitulo('Vouchers');
        setSubtitulo(t("excelImport.massiveCreation"));
        break;
      case url + "/nuevoTicket":
        setTitulo('Ticket');
        setSubtitulo(t("button.create"));
        break;
      case url + "/nuevoTicket/importarExcel":
        setTitulo('Ticket');
        setSubtitulo(t("excelImport.massiveCreation"));
        break;
      case url + "/nuevoTicket/recepcion":
        setTitulo('Ticket');
        setSubtitulo(t("excelImport.massiveCreation"));
        break;
      case url + "/editar":
        setTitulo("Datos del evento");
        setSubtitulo('');
        break;
      case url + "/mis-asistentes":
        setTitulo("Mis asistentes");
        setSubtitulo('Acá podés ver la lista de personas que escaneaste.');
        break;
      case url + "/caja-stock":
        setTitulo("Caja y Stock");
        setSubtitulo('Acá podés asignar cajas a tus vendedores y manejar el stock de tus tarifas.');
        break;
        case url + "/ventas-caja":
        setTitulo("Historial de Ventas");
        setSubtitulo('Acá podés ver el historial de ventas realizadas de forma presencial.');
        break;
      default:
        setIcono('');
        setTitulo('');
        setSubtitulo('');
        break;
    }
  }, [location.pathname, param.id, t]);

  const handleGoBack = () => {
    if (location.pathname.split('/').length > 4) {
      const basePath = location.pathname.split('/').slice(0, 4).join('/');
      history.push(basePath);
    } else {
      history.push(`/eventos/${param.id}`);
    }
  }
  return (
    <>
      {!isVentaPresencial && !esVendedorOTesorero && (
        <header
        >
          <div className="d-flex flex-column" style={{ padding: "25px 35px" }}>
            {showBackButton && (
              <div className="mb-3">
                <Tooltip title="Volver">
                  <IconButton
                    onClick={handleGoBack}
                    size="small"
                    sx={{
                      color: "#5656ff",
                      border: "none",
                      borderRadius: "4px",
                      padding: "4px 12px",
                      "&:hover": {
                        backgroundColor: "rgba(11, 0, 98, 0.04)"
                      }
                    }}
                  >
                    <ArrowBack fontSize="small" />
                    <span style={{
                      marginLeft: "4px",
                      fontSize: "14px",
                      fontFamily: "Bricolage Grotesque, serif"
                    }}>
                      Volver
                    </span>
                  </IconButton>
                </Tooltip>
              </div>
            )}

            {!esVendedorOTesorero && (titulo.length !== 0 || subtitulo.length !== 0) && (
              <div className="d-flex align-items-center">
                <div className="d-flex justify-content-between align-items-center" style={{ flex: 1 }}>
                  <div className="d-flex">
                    <div>
                      <h2 style={{ margin: "0px", display: "flex", alignItems: "center", fontWeight: "500", color: "#0b0062" }}>{titulo}</h2>
                      {subtitulo.length !== 0 && (
                        <h6 className="text-secondary fw-normal">{subtitulo}</h6>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </header>
      )}
    </>

  )
}